import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { getContentByJenis } from "../services/api";
import { useLanguage, pickLang } from "../contexts/LanguageContext";
import "./Dokumen/Dokumen.css";

/**
 * Halaman generik untuk menu bertipe 'content'.
 * URL: /halaman/:jenis
 * Mengambil konten dari tabel Content berdasarkan kolom jenis.
 */
const ContentPage = () => {
  const { jenis } = useParams();
  const { language } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setContent(null);
    getContentByJenis(jenis)
      .then((response) => {
        if (response.data.success) {
          setContent(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching content:", err);
      })
      .finally(() => setLoading(false));
  }, [jenis]);

  const title =
    pickLang(content, "judul", language) ||
    jenis?.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const isi = pickLang(content, "isi", language);

  // Link unduh (/api/content/download/...) ditangani langsung browser.
  // Jangan intercept dengan fetch()+blob() — file besar (90MB+) gagal karena
  // seluruh file dimuat ke memori; backend sudah mengirim Content-Disposition.

  return (
    <div>
      <div className="page-header">
        <Container>
          <h1>{title}</h1>
        </Container>
      </div>

      <Container className="content-section">
        {loading ? (
          <div className="loading-container">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="loading-text">
              {language === "en" ? "Loading content..." : "Memuat konten..."}
            </p>
          </div>
        ) : (
          <div className="document-content">
            {isi ? (
              <div dangerouslySetInnerHTML={{ __html: isi }} />
            ) : (
              <div className="empty-state">
                <div className="empty-state-icon">📄</div>
                <h3>
                  {language === "en" ? "No Content Yet" : "Belum Ada Konten"}
                </h3>
                <p>
                  {language === "en"
                    ? "Content for this page is not yet available."
                    : "Konten untuk halaman ini belum tersedia."}
                </p>
              </div>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default ContentPage;
